

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NewsPageTagsComponent from '../components/NewsPageTagsComponent';
import { getDataNewsByTagIfNeeded } from '../actions/NewsActions';

const mapStateToProps = (state) => ({
    newsTagData: state.news.newsTagData,
    isLoading: state.news.isLoading,
    noticeText: state.news.noticeText,
    currentTagTitle: state.news.currentTagTitle,
});

const mapDispatchToProps = (dispatch) => ({
    getDataNewsByTagIfNeeded: (qtdNews, qtdInit, tag) => {
        dispatch(getDataNewsByTagIfNeeded(qtdNews, qtdInit, tag));
    },
});

const NewsPageTagsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewsPageTagsComponent);

export default withRouter(NewsPageTagsContainer);
